/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ago_Solid_Butterfly_ChopInputs */

const en_ago_solid_butterfly_chop = /** @type {(inputs: Ago_Solid_Butterfly_ChopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absolute`)
};

const de_ago_solid_butterfly_chop = /** @type {(inputs: Ago_Solid_Butterfly_ChopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absolut`)
};

/**
* | output |
* | --- |
* | "Absolute" |
*
* @param {Ago_Solid_Butterfly_ChopInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ago_solid_butterfly_chop = /** @type {((inputs?: Ago_Solid_Butterfly_ChopInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ago_Solid_Butterfly_ChopInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ago_solid_butterfly_chop(inputs)
	return de_ago_solid_butterfly_chop(inputs)
});